"use strict";

import BetragsrechnerRegistry from "../services";

import BetragsrechnerPersonalkosten from "./betragsrechner.js";
import BetragsrechnerPersonalkostenController from "./controller";

const BetragsrechnerPersonalkostenModul = angular.module("dias.betragsrechner.personalkosten_perioden", [
  BetragsrechnerRegistry.name,
]);

BetragsrechnerPersonalkostenModul.config(/*@ngInject*/ BetragsrechnerRegistryProvider => {
  BetragsrechnerRegistryProvider.register("personalkosten_perioden", BetragsrechnerPersonalkosten);
})
  .component("personalkostenperioden", BetragsrechnerPersonalkostenController);

export default BetragsrechnerPersonalkostenModul;
